import React from 'react';
import Card from '../../../shared/components/Card';
import { useLanguage } from '../../../shared/contexts/LanguageContext';
import useTranslation from '../../../shared/hooks/useTranslation';

const AdminSection: React.FC = () => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  const adminFeatures = [
    {
      icon: '/images/icon-bat.png',
      titleKey: 'admin.buildings.title',
      descriptionKey: 'admin.buildings.description',
      color: 'blue',
      items: ['Placement stratégique', 'Postes limités par bâtiment', 'Restitution possible (70% remboursé)', 'Bonus actifs si bâtiment actif'],
    },
    {
      icon: '/images/icons8-homme-debout-50.png',
      titleKey: 'admin.personnel.title',
      descriptionKey: 'admin.personnel.description',
      color: 'green',
      items: ['1 à 2 bonus par membre', 'Bonus cumulables par bâtiment', 'Retraite automatique', 'Transferts entre bâtiments'],
    },
    {
      icon: '/images/icons8-demande-de-services-de-transport-de-véhicules-de-taxi-dans-une-cabine-de-taxi-35-64.png',
      titleKey: 'admin.vehicles.title',
      descriptionKey: 'admin.vehicles.description',
      color: 'purple',
      items: ['Kilométrage = risque de panne', 'Pannes probabilistiques', 'Possédés à vie', 'Transferts possibles'],
    },
    {
      icon: '/images/icons8-courir-60.png',
      titleKey: 'admin.bonus.title',
      descriptionKey: 'admin.bonus.description',
      color: 'yellow',
      items: ['Plafond général des bonus', 'Bonus Premium hors plafond', 'Cumulables par bâtiment', 'Recalcul immédiat'],
    },
    {
      icon: '/images/argent_jeu.png',
      titleKey: 'admin.premium.title',
      descriptionKey: 'admin.premium.description',
      color: 'indigo',
      items: ['Bonus supplémentaires', 'Hors plafond normal', 'Complexité accrue', 'Pas pay-to-win'],
    },
    {
      icon: '/images/icon-cta.png',
      titleKey: 'admin.realtime.title',
      descriptionKey: 'admin.realtime.description',
      color: 'red',
      items: ['Dashboard avant activation', 'Prise d\'appel = temps réel', 'Gestion continue', 'Interventions en direct'],
    },
  ];

  const colorClasses = {
    blue: 'from-blue-600 to-blue-800 border-blue-600/50 hover:border-blue-400',
    green: 'from-green-600 to-green-800 border-green-600/50 hover:border-green-400',
    purple: 'from-purple-600 to-purple-800 border-purple-600/50 hover:border-purple-400',
    yellow: 'from-yellow-600 to-yellow-800 border-yellow-600/50 hover:border-yellow-400',
    indigo: 'from-indigo-600 to-indigo-800 border-indigo-600/50 hover:border-indigo-400',
    red: 'from-red-600 to-red-800 border-red-600/50 hover:border-red-400',
  };

  return (
    <section className="py-20 relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-6">
            <span className="text-gradient">{t('admin.title')}</span>
          </h2>
          <p className="text-2xl text-gray-400 max-w-4xl mx-auto leading-relaxed">
            {t('admin.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {adminFeatures.map((feature, index) => (
            <Card 
              key={index} 
              hover 
              glow 
              className={`p-8 bg-gradient-to-br ${colorClasses[feature.color as keyof typeof colorClasses]}`}
            >
              <div className="text-center">
                <div className={`w-24 h-24 bg-gradient-to-br ${colorClasses[feature.color as keyof typeof colorClasses].split(' ')[0]} ${colorClasses[feature.color as keyof typeof colorClasses].split(' ')[1]} rounded-3xl flex items-center justify-center mx-auto mb-6 transition-transform duration-300 hover:scale-110`}>
                  <img src={feature.icon} alt={t(feature.titleKey)} className="w-14 h-14" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{t(feature.titleKey)}</h3>
                <p className="text-gray-300 mb-6 text-lg">{t(feature.descriptionKey)}</p>
                <ul className="text-sm text-gray-400 space-y-2 text-left">
                  {feature.items.map((item, i) => (
                    <li key={i}>• {item}</li>
                  ))}
                </ul>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdminSection;

